module.exports = __webpack_public_path__ + "video-d97bcc92587fc1ec3122.svg";